import { render } from "./CompletedPurchaseOrdersView.vue?vue&type=template&id=ab8793f0&scoped=true"
import script from "./CompletedPurchaseOrdersView.vue?vue&type=script&lang=js"
export * from "./CompletedPurchaseOrdersView.vue?vue&type=script&lang=js"

import "./CompletedPurchaseOrdersView.vue?vue&type=style&index=0&id=ab8793f0&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8793f0"]])

export default __exports__